import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export type DownloadOrdersJob = {
  pairId: number;
  downloadStateId: number | null;
  downloadFileId: number | null;
  status: string | null;
  startedAt: string;
};

type DownloadOrdersState = {
  jobs: Record<number, DownloadOrdersJob>;
};

type DownloadOrdersActions = {
  setJob: (pairId: number, job: DownloadOrdersJob) => void;
  updateJob: (pairId: number, patch: Partial<DownloadOrdersJob>) => void;
  clearJob: (pairId: number) => void;
  getJob: (pairId: number) => DownloadOrdersJob | undefined;
};

const downloadOrdersSlice: StateCreator<DownloadOrdersState & DownloadOrdersActions> = (
  set,
  get,
) => ({
  jobs: {},

  setJob: (pairId, job) =>
    set(state => ({
      jobs: { ...state.jobs, [pairId]: job },
    })),

  updateJob: (pairId, patch) =>
    set(state => {
      const current = state.jobs[pairId];
      if (!current) return state;
      return { jobs: { ...state.jobs, [pairId]: { ...current, ...patch } } };
    }),

  clearJob: pairId =>
    set(state => {
      const next = { ...state.jobs };
      delete next[pairId];
      return { jobs: next };
    }),

  getJob: pairId => get().jobs[pairId],
});

const persistedDownloadOrdersStore = persist<DownloadOrdersState & DownloadOrdersActions>(
  downloadOrdersSlice,
  {
    name: `${window.location.origin}/download-orders`,
  },
);

export const useDownloadOrdersStore = create(persistedDownloadOrdersStore);
